module.exports = __webpack_public_path__ + "img/dsci0063.b439c285.jpg";